export default __webpack_public_path__ + "static/media/spoon.1f84eaec.svg";